import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { Paginated, User, UserRole } from "@/types";

export function useUsers(
  filters: {
    search?: string;
    cursor?: string;
    limit?: number;
  } = {},
) {
  return useQuery({
    queryKey: ["users", filters],
    queryFn: () => {
      const params: Record<string, string> = {
        limit: String(filters.limit ?? 25),
      };
      if (filters.search) params.search = filters.search;
      if (filters.cursor) params.cursor = filters.cursor;
      return api.get<Paginated<User>>("/admin/users", params);
    },
  });
}

export function useUpdateUserRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, role }: { id: string; role: UserRole }) =>
      api.put<User>(`/admin/users/${id}/role`, { role }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["users"] }),
  });
}

export function useUserVenues(userId: string, enabled = true) {
  return useQuery({
    queryKey: ["user-venues", userId],
    queryFn: () => api.get<string[]>(`/admin/users/${userId}/venues`),
    enabled,
  });
}

export function useSetUserVenues() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, venueIds }: { userId: string; venueIds: string[] }) =>
      api.put<string[]>(`/admin/users/${userId}/venues`, { venueIds }),
    onSuccess: (_, { userId }) =>
      queryClient.invalidateQueries({ queryKey: ["user-venues", userId] }),
  });
}
